import { createFileRoute, redirect } from '@tanstack/react-router'

/** The page moved twice: Hierarchy became Workspaces (STC-30), then
 * Projects. Kept as a redirect so bookmarks and any `?sel=` deep links an
 * operator saved still land.
 *
 * The old page's kinds were `node` / `project`; both are entities now (a
 * project IS an entity), so the selection carries across as one. */
const KIND_MAP: Record<string, 'entity'> = {
  node: 'entity',
  project: 'entity',
}

export const Route = createFileRoute('/hierarchy')({
  beforeLoad: ({ search }) => {
    const raw = search as { sel?: unknown; selKind?: unknown }
    const sel = typeof raw.sel === 'string' ? raw.sel : undefined
    const selKind =
      typeof raw.selKind === 'string' ? KIND_MAP[raw.selKind] : undefined
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router's documented redirect pattern throws a Redirect object
    throw redirect({ to: '/projects', search: { sel, selKind } })
  },
})
